export default __webpack_public_path__ + "static/media/planta-t-1.69857c13.jpg";